import React, { useEffect, useState } from "react";

import {
  CButton,
  CCollapse,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CListGroup,
  CListGroupItem,
  CRow,
  CPagination,
  CInputCheckbox,
  CCol,
  CSwitch
} from "@coreui/react";
import { ArrowLeft, Plus } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";

import ApplicatedQuestion from "./ApplicatedQuestion/ApplicatedQuestion";
import QuestionCreator from "./QuestionCreator";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "./styles.css";

const QuestionImportModal = props => {
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [allDisciplines, setAllDisciplines] = useState([
    { id: -1, name: "Carregando" }
  ]);
  const [disciplines, setDisciplines] = useState([
    { id: -1, name: "Carregando" }
  ]);
  const [discipline, setDiscipline] = useState(1);
  const [segment, setSegment] = useState(null);
  const [segmentAbility, setSegmentAbility] = useState(null);
  const [objective, setObjective] = useState(null);
  const [objectives, setObjectives] = useState([]);
  const [loadingObjectives, setLoadingObjectives] = useState(false);
  const [objectiveAbility, setObjectiveAbility] = useState(null);
  const [ability, setAbility] = useState(null);
  const [types, setTypes] = useState([]);
  const [difficulties, setDifficulties] = useState([]);
  const [segments, setSegments] = useState([]);
  const [type, setType] = useState(null);
  const [filterSegment, setFilterSegment] = useState(null);
  const [filterSerie, setFilterSerie] = useState(null);
  const [difficulty, setDifficulty] = useState(null);
  const [mine, setMine] = useState(false);
  const [currentType, setCurrentType] = useState("");
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [handleQuestionsTrigger, setHandleQuestionsTrigger] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [changeFilter, setChangeFilter] = useState(false);

  const [showSelectionWarning, setShowSelectionWarning] = useState(false);

  useEffect(() => {
    setDiscipline(null);
    handleUpdate();
  }, []);

  useEffect(() => {
    if (loadingObjectives) {
      handleUpdateDiscipline(segment);
    }
  }, [loadingObjectives]);

  useEffect(() => {
    handleQuestions();
  }, [handleQuestionsTrigger]);

  useEffect(() => {
    updateFilter();
  }, [changeFilter]);

  const handleUpdate = async () => {
    try {
      axios
        .all([
          axios.get(`${URL.api}evaluation/question/getFilterStructure`, {
            params: { discipline },
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}classification/discipline/list`, {
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}evaluation/type_question/list`, {
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}classification/difficulty_level/list`, {
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}classification/serie/getSeriesBySegments`, {
            headers: { authorization: `Bearer ${props.user.token}` }
          })
        ])
        .then(
          axios.spread(
            (
              resSegments,
              resDisciplines,
              resTypes,
              resDifficulties,
              resSeries
            ) => {
              const currAllDisciplines =
                resDisciplines.data.data?.map(item => ({
                  id: item.id,
                  name: item.name
                })) || [];
              const currDiscipline =
                resDisciplines.data.data?.length > 0
                  ? resDisciplines.data.data[0].id
                  : null;
              const currSegment = resSegments.data.data?.find(
                item => item.id === currDiscipline
              );

              setDisciplines(resSegments.data.data || []);
              setAllDisciplines(currAllDisciplines);
              setSegment(currSegment?.segments[0].id);
              setSegmentAbility(currSegment?.segments[0].id);
              setObjectiveAbility(currSegment?.segments[0].objectives[0].id);
              setTypes(resTypes.data.data);
              setDifficulties(resDifficulties.data.data);
              setSegments(resSeries.data.data);
            }
          )
        );
    } catch (error) {
      toastr.error("Erro", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateDiscipline = async segment => {
    if (!discipline) {
      toastr.warning("Atenção", "Selecione um componente curricular");
    }

    try {
      await axios
        .get(`${URL.api}evaluation/question/getObjectivesByStructure`, {
          params: {
            discipline,
            segment,
            mine
          },
          headers: { authorization: `Bearer ${props.user.token}` }
        })
        .then(res => {
          setObjectives(res.data.data);
        });
    } catch (error) {
      toastr.error("Erro", error.message);
    } finally {
      setLoadingObjectives(false);
      setCreating(false);
    }
  };

  const updateFilter = () => {
    setLoading(true);
    setLoadingQuestions(true);
    setCreating(false);

    try {
      axios
        .get(`${URL.api}evaluation/question/getFilterStructure`, {
          params: {
            discipline,
            type,
            difficulty,
            mine,
            segment: filterSegment,
            serie: filterSerie
          },
          headers: { authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          setDisciplines(resp.data.data);
          setQuestions([]);
          setCurrPage(1);
        });
    } catch (error) {
      toastr.error("Erro", error.message);
    } finally {
      setLoading(false);
      setLoadingQuestions(false);
    }
  };

  const handleQuestions = async (page = 1) => {
    setLoadingQuestions(true);

    try {
      axios
        .get(`${URL.api}evaluation/question/getQuestionsByStructure`, {
          params: {
            module: objective,
            discipline,
            type,
            difficulty,
            mine,
            page_size: 1,
            page
          },
          headers: {
            authorization: `Bearer ${props.user.token}`
          }
        })
        .then(resp => {
          if (resp.data.success) {
            setQuestions(resp.data.data);
            setCurrPage(resp.data.meta.current_page);
            setLastPage(resp.data.meta.last_page);
          }
        });
    } catch (error) {
      toastr.error("Erro", error.message);
    } finally {
      setLoadingQuestions(false);
      setCreating(false);
    }
  };

  const onSave = async (question, edit) => {
    if (props.importQuestion) {
      selectQuestion(true, question.id);
    }

    setLoading(true);
    setLoadingQuestions(true);
    setDiscipline(question.discipline_id);
    setMine(true);
    setAbility(question.ability_id);
    setType(null);
    setDifficulty(null);
    setSegment(question.segment_id);
    setFilterSegment(question.segment_id);
    setFilterSerie(0);
    setObjective(question.objective_id);

    try {
      const filterStructureResponse = await axios.get(
        `${URL.api}evaluation/question/getFilterStructure`,
        {
          params: {
            discipline: question.discipline_id,
            ability: question.ability_id,
            segment: question.segment_id,
            type: null,
            difficulty: null,
            mine: true,
            filter_type: "educandus"
          },
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );

      setDisciplines(filterStructureResponse.data.data);
      setCurrentType("educandus");
      setLoading(false);

      const lastPageRequest = await axios.get(
        `${URL.api}evaluation/question/getQuestionsByStructure`,
        {
          params: {
            ability: question.ability_id,
            module: null,
            discipline: question.discipline_id,
            type: null,
            difficulty: null,
            mine: true,
            filter_type: "educandus",
            page_size: 1,
            page: 1
          },
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );

      const searchResponse = await axios.get(
        `${URL.api}evaluation/question/getQuestionsByStructure`,
        {
          params: {
            ability: question.ability_id,
            module: null,
            discipline: question.discipline_id,
            type: null,
            difficulty: null,
            mine: true,
            filter_type: "educandus",
            page_size: 1,
            page: lastPageRequest.data.meta.last_page
          },
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );
      const currentIndex = searchResponse.data.data.findIndex(
        item => item.id === question.id
      );

      setQuestions(searchResponse.data.data);
      setLastPage(searchResponse.data.meta.last_page);
      setLoadingQuestions(false);
      setCurrPage(searchResponse.data.meta.current_page);
    } catch (error) {
      toastr.error("Erro", "Erro ao salvar questão");
    }
  };

  const selectQuestion = (checked, id) => {
    const filteredQuestions = selectedQuestions.filter(
      questionId => questionId !== id
    );

    setSelectedQuestions(
      checked ? [...filteredQuestions, id] : filteredQuestions
    );

    if (showSelectionWarning) {
      setShowSelectionWarning(false);
    }
  };

  const handleImportClick = () => {
    if (selectedQuestions.length === 0) {
      setShowSelectionWarning(true);
    } else {
      setShowSelectionWarning(false);
      props.importQuestions(
        selectedQuestions.map(item => ({
          id: item,
          value: 0
        }))
      );
    }
  };

  return (
    <div className="d-flex flex-column w-100 h-100 overflow-hidden p-0">
      {creating ? (
        <div className="d-flex flex-column w-100 h-100">
          <div className="d-flex flex-1 justify-content-center overflow-auto">
            <div className="w-100 mh-100 p-3 overflow-auto">
              <CButton
                color="secondary"
                className="d-flex align-items-center justify-content-center mb-2"
                onClick={() => setCreating(!creating)}
              >
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center justify-content-center h-100">
                    <ArrowLeft size={16} className="mr-1" />
                  </div>

                  <p className="m-0 text-nowrap">Voltar ao banco</p>
                </div>
              </CButton>
              <QuestionCreator
                onActivity={false}
                questionValue={0}
                questionValueChanger={() => null}
                questionId={undefined}
                index={0}
                listChanger={() => null}
                questionDuplicator={() => null}
                questionDeleter={() => null}
                history={props.history}
                types={types}
                abilities={[]}
                onSave={(q, e) => onSave(q, e)}
                filter={{
                  ability,
                  segment,
                  module,
                  discipline,
                  type,
                  difficulty
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <CRow className="border-bottom w-100 row-cols-1 row-cols-sm-2 row-cols-lg-4 p-4 align-items-center">
            <CCol>
              <CFormGroup>
                <CLabel className="text-muted mb-1">
                  Componente Curricular
                </CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isClearable
                    placeholder="Selecione o componente"
                    className="basic-single"
                    classNamePrefix="select"
                    options={allDisciplines}
                    getOptionLabel={option => option.name}
                    getOptionValue={option => option.id}
                    value={allDisciplines.find(item => item.id === discipline)}
                    onChange={e => {
                      e ? setDiscipline(parseInt(e.id)) : setDiscipline(null);
                      setChangeFilter(!changeFilter);
                      setObjective(null);
                      setSegment(null);
                    }}
                  />
                </CInputGroup>
              </CFormGroup>
            </CCol>
            <CCol>
              <CFormGroup>
                <CLabel className="text-muted mb-1">Tipo de Questão</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isClearable
                    placeholder="Selecione o tipo"
                    onChange={e => {
                      e ? setType(parseInt(e.value)) : setType(null);
                      setChangeFilter(!changeFilter);
                      setObjective(null);
                      setSegment(null);
                    }}
                    value={types.find(item => item.value === type)}
                    options={types.map(item => ({
                      value: item.id,
                      label: item.name
                    }))}
                  />
                </CInputGroup>
              </CFormGroup>
            </CCol>
            <CCol>
              <CFormGroup>
                <CLabel className="text-muted mb-1">Dificuldade</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isClearable
                    placeholder="Selecione a dificuldade"
                    onChange={e => {
                      e
                        ? setDifficulty(parseInt(e.value))
                        : setDifficulty(null);
                      setChangeFilter(!changeFilter);
                      setObjective(null);
                      setSegment(null);
                    }}
                    value={difficulties.find(item => item.value === difficulty)}
                    options={difficulties.map(item => ({
                      value: item.id,
                      label: item.name
                    }))}
                  />
                </CInputGroup>
              </CFormGroup>
            </CCol>
            <CCol>
              <div className="d-inline-flex justify-content-between w-100">
                <div className="d-inline-flex align-items-center">
                  <span className="mr-2">{mine ? `Minhas` : `Públicas`}</span>

                  <CSwitch
                    color="primary"
                    shape="pill"
                    checked={mine}
                    onChange={e => {
                      setMine(!mine);
                      setChangeFilter(!changeFilter);
                      setSegment(null);
                    }}
                  />
                </div>
                <CButton
                  color="secondary"
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => setCreating(!creating)}
                >
                  <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <Plus size={16} className="mr-1" />
                    </div>
                    <p className="m-0 text-nowrap">Criar questão</p>
                  </div>
                </CButton>
              </div>
            </CCol>
          </CRow>

          <div className="question-bank-split d-flex flex-column flex-md-row w-100 flex-1">
            {discipline && (
              <div className="question-importer-modal-sidebar">
                <div className="overflow-auto flex-1">
                  <CListGroup>
                    {disciplines?.map(auxSegment => (
                      <>
                        <CListGroupItem
                          action
                          key={auxSegment.segment_id}
                          className="question-importer-segments question-importer-list-item rounded-0 d-flex align-items-center justify-content-between"
                          onClick={() => {
                            setSegment(
                              segment === auxSegment.segment_id
                                ? null
                                : auxSegment.segment_id
                            );
                            setObjective(null);
                            if (segment !== auxSegment.segment_id) {
                              setLoadingObjectives(true);
                            }
                          }}
                        >
                          <span className="small text-uppercase text-primary font-weight-semibold">
                            {auxSegment.segment_name}{" "}
                          </span>
                          <i
                            className={
                              segment === auxSegment.segment_id
                                ? "fa fa-chevron-up small"
                                : "fa fa-chevron-down small"
                            }
                          />
                        </CListGroupItem>
                        <CCollapse show={segment === auxSegment.segment_id}>
                          {loadingObjectives ? (
                            <Loading />
                          ) : (
                            <CListGroup>
                              {objectives.map(obj =>
                                obj.module.map(item => (
                                  <React.Fragment key={item.id}>
                                    <CListGroupItem
                                      action
                                      key={item.id}
                                      className="question-importer-list-item rounded-0 d-flex align-items-center justify-content-between"
                                      onClick={() => {
                                        setObjective(item.id);
                                        setSegmentAbility(
                                          auxSegment.segment_id
                                        );
                                        setCurrPage(1);
                                        setHandleQuestionsTrigger(
                                          !handleQuestionsTrigger
                                        );
                                      }}
                                    >
                                      <span className="ml-3">
                                        {item.description}
                                      </span>
                                    </CListGroupItem>
                                  </React.Fragment>
                                ))
                              )}
                            </CListGroup>
                          )}
                        </CCollapse>
                      </>
                    )) || (
                      <div className="w-100 px-2 py-4 small text-muted d-flex align-items-center justify-content-center text-center">
                        Nenhum resultado encontrado
                      </div>
                    )}
                  </CListGroup>
                </div>
              </div>
            )}

            <div className="question-importer-modal-content">
              {discipline === null ? (
                <div className="d-flex w-100 h-100 flex-column">
                  <div className="d-flex align-items-center justify-content-center w-100 flex-1 text-muted">
                    Escolha um componente curricular
                  </div>
                </div>
              ) : objective === null ? (
                <div className="d-flex w-100 h-100 flex-column">
                  <div className="d-flex align-items-center justify-content-center w-100 flex-1 text-muted">
                    Escolha um módulo
                    <span className="d-none d-md-inline">&nbsp;ao lado</span>
                    <span className="d-md-none">&nbsp;acima</span>
                  </div>
                </div>
              ) : questions.length === 0 ? (
                <div className="d-flex w-100 h-100 flex-column">
                  <div className="d-flex align-items-center justify-content-center w-100 flex-1 text-muted">
                    Nenhuma questão encontrada
                  </div>
                </div>
              ) : loadingQuestions ? (
                <div className="d-flex w-100 h-100 flex-column">
                  <div className="d-flex align-items-center justify-content-center w-100 flex-1 text-muted">
                    <Loading />
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-column w-100 h-100">
                  <div className="d-flex flex-1 justify-content-center overflow-auto">
                    <div className="w-100 mh-100 p-3 overflow-auto">
                      <ApplicatedQuestion
                        key={questions[0]?.id}
                        questionId={questions[0]?.id}
                        questionOrder={currPage}
                        prototype
                        editable={false}
                        segment={segment}
                        onDelete={() => {
                          setObjective(null);
                          setSegment(null);
                        }}
                        onSave={(q, e) => onSave(q, e)}
                      />
                    </div>
                  </div>
                  <div
                    className="p-3 w-100" // Removido o d-flex para empilhar os elementos
                    style={{ borderTop: "1px solid rgba(0,0,0,0.125)" }}
                  >
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <CPagination
                        className="m-0"
                        addListClass="m-0"
                        activePage={currPage}
                        pages={lastPage}
                        onActivePageChange={page => {
                          setCurrPage(page);
                          handleQuestions(page);
                        }}
                      />
                      {props.importQuestion && (
                        <div className="d-flex align-items-center">
                          <CFormGroup variant="custom-checkbox" inline>
                            <CInputCheckbox
                              custom
                              id="inline-checkbox"
                              name="inline-checkbox"
                              checked={selectedQuestions.includes(
                                questions[0]?.id
                              )}
                              onChange={e =>
                                selectQuestion(
                                  e.target.checked,
                                  questions[0]?.id
                                )
                              }
                            />
                            <CLabel
                              variant="custom-checkbox"
                              htmlFor="inline-checkbox"
                            >
                              Selecionar questão
                            </CLabel>
                          </CFormGroup>
                          <CButton color="primary" onClick={handleImportClick}>
                            Importar selecionadas
                          </CButton>
                        </div>
                      )}
                    </div>
                    {showSelectionWarning && (
                      <div className="w-100 text-right mt-2">
                        <small className="text-danger">
                          Nenhuma questão foi selecionada, por favor selecione
                          ao menos uma para continuar.
                        </small>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps, null)(QuestionImportModal);
